import AlterarSenha from '@/modules/login/alterar-senha/AlterarSenha.vue';

export default {
  path: '/redefinir-senha/:chave',
  name: 'redefinir-snha',
  components: {
    // header: HeaderExterno,
    default: AlterarSenha,
  },
};
